import { BodyText, Eyebrow, Stack } from '@servicetitan/design-system';
import { tokens } from '@servicetitan/tokens/core';
import { StyledTag } from './CustomerDetailsField.styled';
import { Contact } from '@api/generated/graphql';
import ContactMethodLink from '@components/ContactMethodLink/ContactMethodLink';

interface CustomerDetailsFieldProps {
  title: string;
  content: Contact | string;
  contentLocator?: string;
  badgeValue?: number;
  customTaskAttributes?: Record<string, unknown>;
}

export const CustomerDetailsField = ({
  title,
  content,
  badgeValue,
  contentLocator,
  customTaskAttributes,
}: CustomerDetailsFieldProps) => {
  const isContact = typeof content !== 'string';

  return (
    <Stack direction='column' spacing={1}>
      <Eyebrow size='medium'>{title}</Eyebrow>
      <Stack id={contentLocator} spacing={1} alignItems='center'>
        {isContact ? (
          <ContactMethodLink
            locator={contentLocator}
            contact={content}
            customTaskAttributes={customTaskAttributes}
          />
        ) : (
          <BodyText>{content}</BodyText>
        )}

        {!!badgeValue && (
          <StyledTag badge compact color={tokens.colorNeutral0}>
            {`+${badgeValue}`}
          </StyledTag>
        )}
      </Stack>
    </Stack>
  );
};

export default CustomerDetailsField;
